module.exports = __webpack_public_path__ + "img/image-collection-sliding-overlays.05f8e973.png";